import Vue from "vue";
import globalVar from "./Config/config";

var API_URL = globalVar.apiUrl;
import axios from "axios";
import router from "./router";

let adminInstance = axios.create();
adminInstance.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem("isLoggedin");
    if (token != null || token != "") {
      request.headers.common["Authorization"] = `Bearer ${token}`;
      request.headers.common["Content-Type"] = "application/json";
    }
    return request;
  },

  function (error) {
    if (error.response.status === 401) {
      // if you ever get an unauthorized, logout the user
      localStorage.removeItem("userPermissions");
      localStorage.removeItem("isLoggedin");
      localStorage.removeItem("email");
      localStorage.removeItem("password");
      router.push({ name: "login" });
      // you can also redirect to /login if needed !
    }
  }
);

adminInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status == 401) {
      localStorage.removeItem("userPermissions");
      localStorage.removeItem("isLoggedin");
      localStorage.removeItem("email");
      localStorage.removeItem("password");
      router.push({ name: "login" });
    }
    return Promise.reject(error);
  }
);

let config = {
  headers: {
    "content-type": "multipart/form-data",
  },
};

const API = {
  getNewMarketingContent(params,cb, errorCB) {
    adminInstance
      .post(API_URL + "getNewMarketingContent",params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  dashboardCount(cb, errorCB) {
    adminInstance
      .get(API_URL + "dashboardCount")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  rsvpDropdown(cb, errorCB) {
    adminInstance
      .get(API_URL + "rsvpDropdown")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  userDirectLogin(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "userDirectLogin", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUserDetails(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getUserDetails", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  currentWeekDoc(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "currentWeekDocs", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  rsvpAttendees(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "rsvpAttendees", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  deleteScheduler(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "deleteScheduler", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  addRsvp(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "addRsvp", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  editRsvp(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "editRsvp", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  deleteRsvp(id, cb, errorCB) {
    adminInstance
      .get(API_URL + "deleteRsvp/" + id)
      .then(resp => {
        cb(resp);
      })
      .catch(err => {
        errorCB(err);
      });
  },
  updateFoucs(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateFoucs", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAllFoucs(cb, errorCB) {
    adminInstance
      .get(API_URL + "getAllFoucs")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getFocuses(params,cb, errorCB) {
    adminInstance
      .post(API_URL + "getFocuses",params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  updateAwardContent(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateAwardContent", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAwardById(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAwardById", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  editHomeVideo(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "editHomeVideo", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  activeDeactiveHomeVideo(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "activeDeactiveHomeVideo", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  deleteHomeVideo(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "deleteHomeVideo", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  allHomeVideo(cb, errorCB) {
    adminInstance
      .get(API_URL + "allHomeVideo")
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  addHomeVideo(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "addHomeVideo", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  activeDeactiveContent(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "activeDeactiveContent", params)
      .then((resp) => {
        cb(resp);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getWebContent(cb, errorCB) {
    adminInstance
      .get(API_URL + "getWebContent")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  updateHomeContent(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateHomeContent", params, config)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAllArchiveDocuments(cb, errorCB) {
    adminInstance
      .get(API_URL + "getAllArchiveDocuments")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAllDocuments(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllDocuments", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  updateDocument(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateDocument", params, config)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  updateCurrentWeeks(params) {
    adminInstance
      .post(API_URL + "update-current-weeks", params)
      .then((resp) => {
        // cb(resp.data);
      })
      .catch((err) => {
        // errorCB(err);
      });
  },
  addDocument(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "addDocument", params, config)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getDocumentdetails(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getDocumentdetails", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getWeeksByModule(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getWeeksByModule", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAllModules(cb, errorCB) {
    adminInstance
      .get(API_URL + "getAllModules")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAllVenues(cb, errorCB) {
    adminInstance
      .get(API_URL + "getAllVenues")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getAllSkills(cb, errorCB) {
    adminInstance
      .get(API_URL + "getAllSkills")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  deletePackingItems(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "deletePackingItems", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  editSeminar(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "editSeminar", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  allPackingItems(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "allPackingItems", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  allPackingItemsByModulePdf(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "allPackingItemsByModulePdf", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  allPackingItemsByModule(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "allPackingItemsByModule", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  addSeminar(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "addSeminar", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getUserForDropdownList(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getUserForDropdownList", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  publishDraftTemplate(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "publishDraftTemplate", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  deleteDraftEmail(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "deleteDraftEmail", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getDraftEmailById(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getDraftEmailById", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getDraftedMailTemplates(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getDraftedMailTemplates", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  saveAsDraftEmail(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "saveAsDraftEmail", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getWebinarScheduleById(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getWebinarScheduleById", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getWebinarSchedule(cb, errorCB) {
    adminInstance
      .get(API_URL + "getWebinarSchedule")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },

  getWeekModules(cb, errorCB) {
    adminInstance
      .get(API_URL + "get-week-modules")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },

  getScheduler(cb, errorCB) {
    adminInstance
      .get(API_URL + "getScheduler")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  resetPassword(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "callResetPassword", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  login(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "login", data)
      .then((resp) => {
        if (resp.status == 201) {
          cb(resp.data);
        } else {
          cb(resp.data);
        }
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },

  checkEmail(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "sendResetPasswordEmail", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },
  deleteClientSpot(data, cb, errorCB) {
    adminInstance
      .delete(API_URL + "spot/delete/" + data, "")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },
  getroles(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "roles", params)
      .then((resp) => {
        if (resp.status == 200) {
          cb(resp.data);
        }
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllMembers(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllMembers", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getMarketingEmailList(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "marketingEmailList", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getMarketingEmailHistory(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "marketingEmailHistory", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getWebinarInfo(params, cb, errorCB) {
    adminInstance
      .get(API_URL + "webinarInformation", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  membersAttemptSurvey(id, cb, errorCB) {
    adminInstance
      .get(API_URL + "memebersurvey/" + id)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAttemptedDetail(surveyID, userID, cb, errorCB) {
    adminInstance
      .get(API_URL + "surveyanswers/" + surveyID + "/" + userID)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getPreviewSurvey(surveyID, cb, errorCB) {
    adminInstance
      .get(API_URL + "preview-survey/" + surveyID)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllSurveys(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "surveys", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getSentSurveys(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "sentsurveys", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  sendSurveys(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "sendSurvey", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        console.log(err);
        errorCB(err.response);
      });
  },
  getQuestions(id, cb, errorCB) {
    adminInstance
      .post(API_URL + "getquestions" , {id:id})
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  deleteSurvey(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "deleteSurvey", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },
  deleteQuestion(id, cb, errorCB) {
    adminInstance
      .delete(API_URL + "deletequestion/"+id)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response.data);
    });
  },
  getAllPosition(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllPosition", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllStatus(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllStatus", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllMemberFocuses(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllMemberFocuses", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  // getRefundTransactions(userId, cb, errorCB) {
  //   adminInstance
  //     .get(API_URL + `getRefundTransactions/${userId}`)
  //     .then((resp) => {
  //       cb(resp.data);
  //     })
  //     .catch((err) => {
  //       errorCB(err.response);
  //     });
  // },
  getAllBilling(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllBilling", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllBillingDetails(params, id, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllBillingDetails/" + id, params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getFilesDownload(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getFilesDownload", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getReferrals(cb, errorCB) {
    adminInstance
      .get(API_URL + "getReferrals")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllEvents(cb, errorCB) {
    adminInstance
      .get(API_URL + "events")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getTopics(cb, errorCB) {
    adminInstance
      .get(API_URL + "topics")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getContentByTopic(cb, errorCB) {
    adminInstance
      .get(API_URL + "content/by/topic")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getMemberdropd(cb, errorCB) {
    adminInstance
      .get(API_URL + "getMemberdropd")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },

  getLandingPagecontent(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getLandingPageContent", params)
      .then((res) => {
        cb(res.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getEmailPageContent(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getEmailPageContent", params)
      .then((res) => {
        cb(res.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getLandingpagesDropdown(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getLandingpagesDropdown", params)
      .then((res) => {
        cb(res.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  updateOrSaveLandingPage(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateOrSaveLandingPage", params)
      .then((res) => {
        cb(res.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
  getServicedropd(cb, errorCB) {
    adminInstance
      .get(API_URL + "getServicedropd")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getRefundTransactions(id,cb, errorCB) {
    adminInstance
      .get(API_URL + "getRefundTransactions/" + id)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getPositions(cb, errorCB) {
    adminInstance
      .get(API_URL + "getPositions")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getStates(cb, errorCB) {
    adminInstance
      .get(API_URL + "getStates")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getMemberships(cb, errorCB) {
    adminInstance
      .get(API_URL + "getMemberships")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  updateMemberStatus(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateMemberStatus", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllLocations(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "locations", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllPermissions(cb, errorCB) {
    adminInstance
      .get(API_URL + "getAllPermissions")
      .then((resp) => {
        if (resp.status == 201) {
          cb(resp.data);
        }
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },
  add_edit_roles(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "add_edit_roles", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  get_edit_roles(id, cb, errorCB) {
    adminInstance
      .get(API_URL + "add_edit_roles/" + id)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },
  getMember(id, cb, errorCB) {
    let data = {
      id: id,
    };
    adminInstance
      .post(API_URL + "getMember",data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  addUpdateMember(data, cb, errorCB) {
    if (!data.id) {
      adminInstance
        .post(API_URL + "members", data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
    } else {
      adminInstance
        .put(API_URL + "members/" + data.id, data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
    }
  },
  updateWebinarinfo(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "createUpdateWebinarScheduler", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  updateWebinar(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateWebinar", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  updateModule(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateModule/update", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  addUpdateSurvey(data, cb, errorCB) {

    if (!data.id) {
      adminInstance
        .post(API_URL + "addSurvey", data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
    } else {
      adminInstance
        .put(API_URL + "updateSurvey/" + data.id, data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
    }
  },
  addTransaction(data, cb, errorCB) {
    if (!data.id) {
      adminInstance
        .post(API_URL + "addTransaction", data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
    }
  },
  updateSpot(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateSpot", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  updateUserProfile(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateUserProfile", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  saveEditorImage(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "saveEditorImage", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAuthUser(data, cb, errorCB) {
    adminInstance
      .get(API_URL + "getUserProfile", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  logout(cb, errorCB) {
    adminInstance
      .post(API_URL + "logout")
      .then((resp) => {
        if (resp.status == 200) {
          cb(resp.data);
        }
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getcleints(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getcleints", params)
      .then((resp) => {
        if (resp.status == 200) {
          cb(resp.data);
        }
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  get_client(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "get_client", data)
      .then((resp) => {
        if (resp.status == 200) {
          cb(resp.data);
        }
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },
  getAllReferrals(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllReferrals", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  addUpdateVendor(data, cb, errorCB) {
    if (!data.VendorID) {
      adminInstance
        .post(API_URL + "addVendor", data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
    } else {
      adminInstance
        .post(API_URL + "updateVendor", data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
    }
  },
  addUpdateVideo(data, cb, errorCB) {
      adminInstance
        .post(API_URL + "addVideo", data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
  },
  addUpdateSeminarVideos(data, cb, errorCB) {
      adminInstance
        .post(API_URL + "addUpdateSeminarVideos", data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });

  },
  getAllVideos(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllVideos", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllSeminarVideos(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllSeminarVideos", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllArchiveVideos(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllArchiveVideos", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getAllVendors(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllVendors", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  getReferredBy(ReferredBy, cb, errorCB) {
    adminInstance
      .post(API_URL + "getReferredBy", ReferredBy)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  deleteVendor(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "deleteVendor", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },
  deleteVideo(data, cb, errorCB) {
    adminInstance
      .delete(API_URL + "deleteVideo/" + data.id, "")
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },
  addUpdateAward(data, cb, errorCB) {
    if (!data.AwardID) {
      adminInstance
        .post(API_URL + "addaward", data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
    } else {
      adminInstance
        .post(API_URL + "updateAward", data)
        .then((resp) => {
          cb(resp.data);
        })
        .catch((err) => {
          errorCB(err.response);
        });
    }
  },
  getAllAwards(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "getAllAwards", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },

  UpdateReferred(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "UpdateReferred", data)
      .then((resp) => {
        // console.log(resp);
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },
  updateRefMemberStatus(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "updateRefMemberStatus", data)
      .then((resp) => {
        // console.log(resp);
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response);
      });
  },

  deleteAward(data, cb, errorCB) {
    adminInstance
      .post(API_URL + "deleteAward", data)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err.response.data);
      });
  },
  sendTestEmail(params, cb, errorCB) {
    adminInstance
      .post(API_URL + "sendTestEmail", params)
      .then((resp) => {
        cb(resp.data);
      })
      .catch((err) => {
        errorCB(err);
      });
  },
};

export default API;
